

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AudioTrustPanel from './Components/AudioTrustPanel';
import Welcome from './Components/Welcome/Welcome';


function App() {
  return (
    <Router>
      <div style={{ padding: '40px', backgroundColor: '#d5dfff', minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/trust" element={<AudioTrustPanel/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;



